import __request__ from "routing/request";
export function history(reportId, sort = "generated_at", page = 1, per_page = 50, order = "asc", query, filters, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/history`, null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function jobStatus(reportId, jobId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/history/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function downloadAsset(reportId, jobId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/history/${jobId}/download`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function downloadAttemptAsset(reportId, jobId, attempt, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/history/${jobId}/${attempt}/download`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
